import React, { Component } from 'react';
import './Common.css';
import './DatePickerInput.css';
import DatePicker from 'react-datepicker';
import moment from 'moment-timezone';

class DatePickerInput extends Component {
    constructor(props) {
      super(props);

        // This binding is necessary to make `this` work in the callback
        this.clearTextInput = this.clearTextInput.bind(this);
        this.isValidDate = this.isValidDate.bind(this);
        this.getDateFromString = this.getDateFromString.bind(this);
        this.inputIsValid = this.inputIsValid.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleRawDateChange = this.handleRawDateChange.bind(this);
    }

    clearTextInput() {
        this.props.onChange(this.props.name, "");
        this.refs["datePicker"].setOpen(false);
    }
  
    getDateFromString(str) {
        if(str === "") { return null; }

        if(/^[0-9][0-9]\/[0-9][0-9]\/[0-9][0-9][0-9][0-9]$/.test(str)) {
            let date = moment(str, "MM/DD/YYYY");
            if(date.isValid() && this.isValidDate(date)) {
                return date;
            }
        }

        return null;
    }

    isValidDate(date) {
        return date.diff(moment().tz('America/Los_Angeles'), 'days') >= 0;
    }

    handleDateChange(date) {
        if(date) {
            this.props.onChange(this.props.name, date.format("MM/DD/YYYY"));
        }
        else {
            this.props.onChange(this.props.name, "");
        }
    }

    handleRawDateChange(event) {
        let value = event.target.value;
        this.props.onChange(this.props.name, value);
    }

    inputIsValid(str) {
        const date = this.getDateFromString(str);
        return str === "" || date !== null;
    }

    render() {  

        return (
            <div style={{position: "relative"}} className="">
                        
            <div className={this.props.value === "" && this.props.disabled === false ? "textBehindInput" : "hide"}>{this.props.blankText}</div>
                <div className={this.props.disabled ? "hide" : ""}>
                    <DatePicker
                    selected={this.getDateFromString(this.props.value)}
                    dateFormat="MM/DD/YYYY"
                    onChange={this.handleDateChange}
                    onChangeRaw={this.handleRawDateChange}
                    className={this.props.className + " transparent"}
                    scrollableYearDropdown={true}
                    showYearDropdown={true}
                    yearDropdownItemNumber={6}
                    placeholderText=""
                    value={this.props.value} 
                    setOpen={false}
                    ref="datePicker"
                    calendarClassName="datepickerCustom"
                    filterDate={this.isValidDate}
                    isClearable={true}
                    disabled={this.props.disabled}>

                        <div style={{textAlign:"center", marginBottom:"15px"}}><button className="btn" onClick={this.clearTextInput}>{this.props.blankText}</button></div>
                    </DatePicker>
                </div>
                <input disabled={true} type="text" className={this.props.disabled ? this.props.className + " disabled" : "hide"}  value={this.props.value === "" ? this.props.blankText : this.props.value}  />

                <div className={!this.props.disabled && !this.inputIsValid(this.props.value) ? "inputError" : "hide"}>Please enter a valid future date (MM/DD/YYYY) or leave blank</div>

                <div className={this.props.hover ? "questionHoverHelp" : "questionHoverHelp hide"}>{this.props.hoverText}</div>
            </div>
        );
    }
  }
  
  export default DatePickerInput;


// WEBPACK FOOTER //
// ./src/components/DatePickerInput.js